export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11068.77f499be.jpg";